export enum FilterActionKeys {
  SET_FILTERS = 'SET_FILTERS',
  SET_FILTERS_PARTIAL = 'SET_FILTERS_PARTIAL'
}
